var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "component" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c("portrait-labels", {
          attrs: { labelList: _vm.componentData.prjOverview }
        }),
        _vm._v(" "),
        _vm.componentData.prjExperience != null &&
        _vm.componentData.prjExperience.length > 0
          ? _c("div", { staticClass: "sub" }, [
              _c("div", { staticClass: "sub-title" }, [
                _vm._v("\n        项目经历\n      ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sub-content" },
                [
                  _c(
                    "el-timeline",
                    [
                      _vm._l(_vm.componentData.prjExperience, function(item) {
                        return _c("el-timeline-item", [
                          _c("div", { staticClass: "timeline-content" }, [
                            _c("div", { staticClass: "timeline-title" }, [
                              _vm._v(_vm._s(item.timeAxis))
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "timeline-detail" },
                              [
                                _vm.trimArray(item.slotInfo) &&
                                _vm.trimArray(item.slotInfo).length
                                  ? _c(
                                      "div",
                                      { staticClass: "slotInfos" },
                                      _vm._l(
                                        _vm.trimArray(item.slotInfo),
                                        function(slotInfo, slotInfoIndex) {
                                          return _c(
                                            "div",
                                            { staticClass: "slotInfo" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(slotInfo) +
                                                  "\n                    "
                                              ),
                                              slotInfoIndex !==
                                              item.slotInfo.length - 1
                                                ? _c("el-divider", {
                                                    attrs: {
                                                      direction: "vertical"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("portrait-labels", {
                                  attrs: { labelList: item.slotLabel }
                                }),
                                _vm._v(" "),
                                item.slotDetail && item.slotDetail.length
                                  ? _c("fold-module", {
                                      attrs: { slotDetail: item.slotDetail }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "timeAxis" },
                        [_c("el-timeline-item")],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main-title" }, [
      _c("div", { staticClass: "square" }),
      _vm._v(" "),
      _c("div", { staticClass: "title-content" }, [_vm._v("项目概览")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }